import { endpoint } from "./endpoint";
const Axios = require("axios");

export async function getSpikeMutsData(variant) {
  try {
    return process.env.NODE_ENV === "production"
      ? Axios.get(endpoint.concat(`3d_structure_spike_mutations_${variant}.json`))
        .then((result) => {
          return result.data;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            // console.log('File not found!');
            // console.log("err :>> ", err);
          } else
            throw err;
          // return [];
        })
      : new Promise((res, rej) => {
        setTimeout(() => {
          let data;
          try {
            data = require(`../assets/data/3d_structure_spike_mutations_${variant}.json`);
          } catch (error) {
            if (error.code === 'MODULE_NOT_FOUND') {
              // console.log('File not found!');
            } else {
              throw error;
            }
          }
          res(data);
        }, 3000);
      });
  } catch (error) {
    // console.log(error);
  }
}
